<template>
  <v-container>
    <h2 class="text-center">Busqueda de Contratos generados</h2>
    <p class="text-center">
      Puede descargar los contrados generados para un estudiante, debe buscar por nombre o carnet del estudiante y podra
      ver y descargar todos los contratos generados para ese estudiante. <b>NOTA:</b> Solo personal autorizado puede
      anular los contratos generados.
    </p>
    <v-row>
      <v-col>
        <v-combobox
          v-model="filtroestudiante"
          :items="estudiantes"
          label="Carnet del estudiante"
          :loading="isloadingestudent"
          loader-height="6"
          placeholder="tecla enter para buscar..."
          hide-details
          outlined
          dense
        ></v-combobox>
      </v-col>
    </v-row>

    <p class="text-center red--text">{{ msg }}</p>

    <v-data-table
      :headers="headers"
      :items="contratos"
      class="elevation-1"
      :loading="loading"
      loading-text="Buscando contratos..."
    >
      <template v-slot:[`item.opciones`]="{ item }">
        <v-icon
          dark
          left
          depressed
          color="green"
          class="mr-1"
          outlined
          data-toggle="modal"
          data-target="#modal-ndescuentoaprob"
          title="Ver detalles"
          @click="vercontrato(item)"
        >
          mdi-eye
        </v-icon>

        <v-icon
          dark
          depressed
          color="orange"
          class="mr-1"
          :disabled="item.loading"
          outlined
          data-toggle="modal"
          data-target="#modal-ndescuentoaprob"
          title="Descargar contrato"
          @click="descargarcontrato(item)"
        >
          mdi-download
        </v-icon>

        <v-icon
          v-if="$store.state.CARGO.id == 14 || $store.state.CARGO.id == 1"
          dark
          left
          depressed
          color="red"
          class="mr-1"
          outlined
          data-toggle="modal"
          data-target="#modal-ndescuentoaprob"
          title="Eliminar contrato"
          @click="aniquilarcontrato(item)"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" xwidth="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Informacion del contrato
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <p class="mt-0 mb-0">
                <b>Participante:</b> <span>{{ item.participante }}</span>
              </p>
              <p class="mt-0 mb-0">
                <b>Carnet:</b> <span>{{ item.participante_ci }}</span>
              </p>
              <p class="mt-0 mb-0">
                <b>Domicilio:</b> <span>{{ item.participante_domicilio }}</span>
              </p>
              <p class="mt-0 mb-0">
                <b>ID:</b> <span>{{ item.participante_id }}</span>
              </p>
              <p class="mt-0 mb-4">
                <b>Nacionalidad:</b> <span>{{ item.participante_nacionalidad }}</span>
              </p>
              <p class="mt-0 mb-0">
                <b>Programa:</b> <span>{{ item.programa_nombre }}</span>
              </p>
              <p class="mt-0 mb-0">
                <b>Tipo:</b> <span>{{ item.programa_tipo }}</span>
              </p>
              <p class="mt-0 mb-0">
                <b>Carga horaria:</b> <span>{{ item.programa_carga_horario }}</span>
              </p>
              <p class="mt-0 mb-0">
                <b>Matricula:</b> <span>{{ item.programa_matricula_monto }}</span>
              </p>
              <p class="mt-0 mb-0">
                <b>Colegiatura:</b> <span>{{ item.programa_colegiatura_monto }}</span>
              </p>
              <p class="mt-0 mb-0">
                <b>Sede:</b> <span>{{ item.ciudad }}</span>
              </p>
              <p class="mt-0 mb-4">
                <b>Direccion:</b> <span>{{ item.direccion }}</span>
              </p>
            </v-col>

            <v-col>
              <p class="mt-0 mb-0">
                <b>Representante:</b> <span>{{ item.representante }}</span>
              </p>
              <p class="mt-0 mb-0">
                <b>Carnet:</b> <span>{{ item.representante_ci }}</span>
              </p>
              <p class="mt-0 mb-4">
                <b>Expedido:</b> <span>{{ item.representante_expedido }}</span>
              </p>
              <p class="mt-0 mb-0">
                <b>Fecha registro:</b> <span>{{ item.fecha_registro }}</span>
              </p>
            </v-col>
          </v-row>

          <v-divider></v-divider>
          <p>
            <b>Modulos del programa:</b>
            <v-data-table :headers="headersmodulos" :items="item.modulos" dense hide-default-footer> </v-data-table>
          </p>

          <v-divider></v-divider>
          <p>
            <b>Plan de pagos del estudiante:</b>
            <v-data-table :headers="headersplan" :items="item.plan_pagos" dense hide-default-footer> </v-data-table>
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="text-center">
      <div style="display: inline-block;" v-if="loading" class="loader"></div>
    </div>

    <div v-show="false"><ABuscarPersona ref="abuscarpersona" v-on:resultadobusquedaest="resultadobusquedaest" /></div>
  </v-container>
</template>

<script>
  import ABuscarPersona from '@/components/ABuscarPersona';
  import xaxios from '@/xaxios';
  export default {
    components: { ABuscarPersona },
    data() {
      return {
        msg: '',
        timeoutHnd: 0,
        filtroestudiante: null,
        isloadingestudent: false,
        loading: false,
        estudiantes: [],
        headers: [
          { text: 'Participante', value: 'participante' },
          { text: 'Programa', value: 'programa_nombre' },
          { text: 'Domicilio', value: 'participante_domicilio' },
          { text: 'Fecha registro', value: 'fecha_registro' },
          { text: 'Opciones', value: 'opciones', width: 150 },
        ],
        headersmodulos: [
          { text: 'Mod #', value: 'numero' },
          { text: 'Modulo', value: 'modulo' },
        ],
        headersplan: [
          { text: 'Cuota', value: 'nro_cuota' },
          { text: 'concepto', value: 'concepto_pago' },
          { text: 'Monto', value: 'monto' },
          { text: 'Fecha pago', value: 'fecha_pago' },
        ],
        contratos: [],
        dialog: false,
        item: {},
      };
    },
    watch: {
      filtroestudiante: function() {
        if (!this.filtroestudiante) {
          this.filtroestudiante = '';
          this.getDatos();
        }
        if (typeof this.filtroestudiante == 'object') {
          this.getDatos();
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.asyncfindestudiante(false);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
        }, 500);
      },
    },
    methods: {
      asyncfindestudiante() {
        this.$refs.abuscarpersona.asyncfindestudiante(false, this.filtroestudiante, this);
      },
      resultadobusquedaest() {},
      getDatos() {
        window.console.log(this.filtroestudiante);
        this.loading = true;
        const vue = this;
        let persona_id = this.filtroestudiante.id;
        let url3 = `${process.env.VUE_APP_API_REST}/api/v1/contratos/${persona_id}/persona`;
        const promise3 = xaxios.get(url3);

        Promise.all([promise3])
          .then(function(values) {
            let data = values[0].data;

            if (!data) {
              vue.msg = 'No se han encontrados contratos.';
            } else {
              data.data.map((x) => {
                x.loading = false;
              });
              vue.contratos = data.data;
            }

            window.console.log('estudiante::', data);
            vue.loading = false;
          })
          .catch((e) => {
            vue.$emit('dataloaded');
            window.console.error(e);
            vue.loading = false;
          });
      },
      vercontrato(item) {
        this.item = item;
        this.dialog = true;
      },
      descargarcontrato(item) {
        this.loading = true;
        item.loading = true;
        const vue = this;
        let contrato_id = item.id;
        let url3 = `${process.env.VUE_APP_API_REST}/api/v1/contratos/${contrato_id}/pdf`;
        xaxios
          .get(url3)
          .then((x) => {
            let datapdf = x.data.data;
            //window.console.log(datapdf);
            const downloadLink = document.createElement('a');
            downloadLink.href = datapdf;
            downloadLink.download = 'Contrato-' + item.participante + '.pdf';
            downloadLink.click();
            vue.loading = false;
            item.loading = false;
          })
          .catch((e) => {
            window.console.error(e);
            vue.loading = false;
            item.loading = false;
          });
      },
      aniquilarcontrato(item) {
        window.console.log(item);
        const vue = this;

        var message = {
          title: 'Confirme que desea eliminar este contrato',
          body:
            '<br> <b>NOTA:</b> Esta accion elimina el contrato permitiendo generar otro de nuevo.<br/>Use esta opcion solo cuando algun dato del contrato desea cambiarse.',
        };
        var options = {
          html: true,
          okText: 'Eliminar contrato',
          cancelText: 'Cancelar',
          reverse: true,
          type: 'hard',
          verification: 'eliminar',
          verificationHelp: 'Escriba "[+:verification]" para proceder.',
          loader: true,
        };
        this.$dialog
          .confirm(message, options)
          .then(function(dialog) {
            vue.loading = true;
            let url = `${process.env.VUE_APP_API_REST}/api/v1/contratos/${item.id}`;
            xaxios
              .delete(url)
              .then((x) => {
                window.console.log(x);
                let res = x.data.data;
                vue.msg = res;
                vue.loading = false;
                vue.contratos = vue.contratos.filter((x) => x.id != item.id);
                dialog.close();
              })
              .catch((e) => {
                window.console.error(e);
                vue.loading = false;
              });
          })
          .catch(function() {});
      },
    },
  };
</script>
